import React, { useEffect } from 'react';
import { colors } from 'theme/colors';
import Grid from '@mui/material/Grid';
import { Typography } from '@mui/material';
import { emptyFieldHolder } from 'components/molecules/CardList';
import { ITableDataSource } from 'models/table';
import { Chips, EChipsVariants } from 'components/atoms/Chips';
import { useGlobalProperty } from 'models/globalPropertyContext';
import Button from 'components/atoms/Button';
import { EButtonVariants } from 'constants/Buttons';
import { useTranslations } from 'hooks/useTranslations';

interface ILicenceAuthoritiesTableCard {
  data: ITableDataSource;
  viewAction: (id: string) => void;
  editAction: (id: string) => void;
}

const LicenceAuthoritiesTableCard = ({
  data,
  viewAction,
  editAction,
}: ILicenceAuthoritiesTableCard) => {
  const { getProperties } = useGlobalProperty();
  const { t } = useTranslations();

  useEffect(() => {
    getProperties();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Grid
      container
      sx={{
        border: `1px solid ${colors.gray200}`,
        borderRadius: '4px',
        overflow: 'hidden',
        mt: 1,
        backgroundColor: colors.gray100,
        p: 2,
        rowGap: 2,
      }}
    >
      <Grid size={{ xs: 12, sm: 6 }}>
        <Typography variant="subtitle2" sx={{ marginBottom: '4px' }}>
          {t('licenceAuthorities.licenceAuthorities.label')}
        </Typography>
        <Typography variant="body2" sx={{ wordBreak: 'break-word' }}>
          {emptyFieldHolder(data.name)}
        </Typography>
      </Grid>
      <Grid size={{ xs: 12, sm: 6 }}>
        <Typography variant="subtitle2" sx={{ marginBottom: '4px' }}>
          {t('licenceAuthorities.status.label')}
        </Typography>
        <Typography variant="body2">
          <Chips
            text={data.isActive ? t('general.active.label') : t('general.inactive.label')}
            variant={data.isActive ? EChipsVariants.success : EChipsVariants.error}
          />
        </Typography>
      </Grid>
      <Grid
        container
        size={{ xs: 12 }}
        spacing={2}
        sx={{
          alignItems: 'center',
          borderTop: `1px solid ${colors.primary100}`,
          pt: 2,
          mt: 1,
        }}
      >
        <Grid size={{ xs: 12, sm: 4, md: 6 }}>
          <Typography variant="button" sx={{ textTransform: 'uppercase' }}>
            {`${t('general.actions.button')}:`}
          </Typography>
        </Grid>
        <Grid size={{ xs: 12, sm: 4, md: 3 }}>
          <Button
            id={`licenceAuthorities_view-button-${data.id}`}
            label={t('general.view.label')}
            variant={EButtonVariants.outlined}
            tableButton
            onClick={() => viewAction(data.id as string)}
            fullWidth
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 4, md: 3 }}>
          <Button
            id={`licenceAuthorities_edit-button-${data.id}`}
            label={t('general.edit.label')}
            variant={EButtonVariants.outlined}
            tableButton
            onClick={() => editAction(data.id as string)}
            fullWidth
          />
        </Grid>
      </Grid>
    </Grid>
  );
};
export default LicenceAuthoritiesTableCard;
